// File: apps/app/src/core/initApp.ts

import { SafeArea } from '@capacitor-community/safe-area'
import { Capacitor } from '@capacitor/core'
import { SplashScreen } from '@capacitor/splash-screen'
import { StatusBar, Style } from '@capacitor/status-bar'

export async function initMobile() {
	try {
		console.log('📱 Initializing mobile environment')

		await StatusBar.setStyle({ style: Style.Default })

		console.log('Configuring safe area')
		await SafeArea.enable({
			config: {
				customColorsForSystemBars: true,
				statusBarColor: '#00000000',
				statusBarContent: 'light',
				navigationBarColor: '#00000000',
				navigationBarContent: 'light',
			},
		})

		// Hide native splash
		await SplashScreen.hide()
	} catch (err) {
		console.error('❌ initMobile error:', err)
	}
}

export async function initWeb() {
	console.log('💻 Initializing Web Environment (Push logic deferred to auth)')
}

function setViewportHeight() {
	const vh = window.visualViewport?.height || window.innerHeight
	document.documentElement.style.setProperty('--vh', `${vh * 0.01}px`)
}

function initViewportFix() {
	// Set initial
	setViewportHeight()

	// Listen for changes
	window.addEventListener('resize', setViewportHeight)
	window.addEventListener('orientationchange', setViewportHeight)
}

export async function initApp() {
	try {
		initViewportFix() // 🧠 always run it

		if (Capacitor.isNativePlatform()) {
			await initMobile()
		} else {
			await initWeb()
		}
	} catch (err) {
		console.error('❌ initApp error:', err)
	}
}
